import React from 'react';
import { Modal, ModalActions } from '../Modal/Modal';
import { LogoutIcon } from '../../../assets/icons/icons';
import { Button } from '../Button/Button';

interface LogoutModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export function LogoutModal({ open, onClose, onConfirm }: LogoutModalProps) {
    return (
        <Modal
            open={open}
            width={420}
            tone="danger"
            title="Выйти из кабинета?"
            description="При выходе из личного кабинета потребуется заново авторизоваться."
            icon={<LogoutIcon />}
            onClose={onClose}
            footer={
                <ModalActions>
                    <Button onClick={onClose}>Отмена</Button>
                    <Button variant="danger" onClick={onConfirm}>
                        Выйти
                    </Button>
                </ModalActions>
            }
        />
    );
}